import { request } from "@/interface/helper";

const str = "nftProject";

export const nftProject = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/nft/project/list" }),
    add: (data) => request({ data, method: "post", url: "/nft/project/add" }),
    detail: (data) => request({ data, method: "post", url: "/nft/project/detail" }),
    edit: (data) => request({ data, method: "post", url: "/nft/project/modify" }),
  },
};
